module.exports = __webpack_public_path__ + "img/EcommIconsAbout.7ac9e6e0.png";